// extracted by mini-css-extract-plugin
module.exports = {"backButton":"Action_backButton__2Ny0N","backIcon":"Action_backIcon__17SzN","cancelIcon":"Action_cancelIcon__2pXN2"};